module.exports = __webpack_public_path__ + "src/assets/img/identity.2be6386f.jpg";